//
// IMPORTANT: This file is a schema and must be managed with extreme care.
// See types/schema/README.md for more information.

import type { ColumnId } from '@/types/enums/column-id'

export const HOLDING_LIST_SCHEMA_VERSION = '1.0'

enum HoldingListConfigKeys {
  FilterPaneState = 'filterPaneState',
  ViewType = 'viewType',
  ColumnState = 'columnState',
}

export interface HoldingListConfig {
  [HoldingListConfigKeys.FilterPaneState]: FilterPaneState
  [HoldingListConfigKeys.ViewType]: ViewType
  [HoldingListConfigKeys.ColumnState]: ColumnState[]
}

export enum FilterPaneState {
  Closed = 'Closed',
  Open = 'Open',
}

export enum ViewType {
  Standard = 'Standard',
  Compact = 'Compact',
}

export type ColumnState = {
  colId: ColumnId
  displayName: string
  visible: boolean
  width?: number
}
